"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkupAddress = void 0;
class LinkupAddress {
    constructor(serverURL, linkupId) {
        if (serverURL[serverURL.length - 1] === '/') {
            serverURL = serverURL.substring(0, serverURL.length - 1);
        }
        this.serverURL = serverURL;
        this.linkupId = linkupId;
    }
    url() {
        return this.serverURL + '/' + this.linkupId;
    }
    static fromURL(url) {
        if (url[url.length - 1] === '/') {
            url = url.substring(0, url.length - 1);
        }
        let urlParts = url.split('/');
        let linkupId = urlParts.pop();
        urlParts.push('');
        let serverUrl = urlParts.join('/');
        return new LinkupAddress(serverUrl, linkupId);
    }
}
exports.LinkupAddress = LinkupAddress;
//# sourceMappingURL=LinkupAddress.js.map